import React from "react";
import "./TodoLoading.css";

function TodoLoading(){

  return (
    <React.Fragment>
    <article key='loading1' className="main--card-todo loading">
    </article>
    
    </React.Fragment>
  );
}
export {TodoLoading};